import home from './src/home.vue'
import FaceList from './src/FaceManager/FaceList.vue' 
import FaceManager from './src/FaceManager/FaceManager.vue' 
import FaceCamera from './src/FaceManager/FaceCamera.vue' 
import FaceAuatarList from './src/FaceManager/FaceAuatarList.vue'
import FaceControl from './src/FaceManager/FaceControl.vue'
import FaceAddControl from './src/FaceManager/FaceAddControl.vue'
import FaceResultControl from './src/FaceManager/FaceResultControl.vue'
let views = {
    home,
    FaceList,
    FaceManager,
    FaceCamera,
    FaceAuatarList,
    FaceControl,
    FaceAddControl,
    FaceResultControl
};

export default views;